import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// import PageHeader from '../../../Components/PageHeader/PageHeader.component';
// import SearchBar from '../SearchDetails/SearchBar/SearchBar.component';
import CourseCard from '../CourseCard/CourseCard.component';
import CourseCatalogHero from './CourseCatalogHero.component';
import { CourseGrid, NoCoursesFound } from './CourseCatalog.styles';
import { MainSection } from '../../../Routes/OtherPages.styles';

const CourseCatalog = ({ courses }) => {
  const [filteredCourses, setFilteredCourses] = useState(courses || []);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTag, setSelectedTag] = useState('all');

  useEffect(() => {
    const safeCourses = Array.isArray(courses) ? courses : [];
    const search =
      typeof searchTerm === 'string' ? searchTerm.toLowerCase() : '';

    const nextFilteredCourses = safeCourses.filter((course) => {
      const courseName =
        course && typeof course.courseName === 'string'
          ? course.courseName
          : '';
      const description =
        course && typeof course.description === 'string'
          ? course.description
          : '';

      const matchesSearch =
        (courseName || '').toLowerCase().includes(search) ||
        (description || '').toLowerCase().includes(search);

      const matchesTag =
        selectedTag === 'all' ||
        (Array.isArray(course?.tags) && course.tags.includes(selectedTag));

      return matchesSearch && matchesTag;
    });

    setFilteredCourses(nextFilteredCourses);
  }, [searchTerm, selectedTag, courses]);

  return (
    <MainSection>
      <div style={{ marginBottom: 'var(--space-xxxl)' }}>
        <CourseCatalogHero
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          selectedTag={selectedTag}
          setSelectedTag={setSelectedTag}
        />
      </div>
      <CourseGrid>
        {filteredCourses?.length > 0 ? (
          filteredCourses?.map((course) => (
            <CourseCard key={course._id} course={course} />
          ))
        ) : (
          <NoCoursesFound>No courses found.</NoCoursesFound>
        )}
      </CourseGrid>
    </MainSection>
  );
};
CourseCatalog.propTypes = {
  courses: PropTypes.array.isRequired,
};

export default CourseCatalog;
